import { render, staticRenderFns } from "./TestSelectFieldWidget.vue?vue&type=template&id=dc8860fa&"
import script from "./TestSelectFieldWidget.vue?vue&type=script&lang=ts&"
export * from "./TestSelectFieldWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TestSelectFieldWidget.vue?vue&type=style&index=0&id=dc8860fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports